module.exports = __webpack_public_path__ + "static/media/close.87359571.svg";